import React from "react";
import { Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { PlanoService, RecadastramentoService } from "../../services";
import {
  WebRecadDadosConclusaoEntidade,
  WebRecadParticipanteDadosEntidade,
  DependenteEntidade,
  WebRecadPublicoAlvoEntidade,
} from "../../entidades";
import { MasterPage } from "..";
import { SituacaoRecad } from "./SituacaoRecad";
import { Passo1 } from "./Passo1";
import { Passo2 } from "./Passo2";
import { ArquivoUploadItem } from "./ArquivoUpload";
import { Passo3 } from "./Passo3";
import { Passo4 } from "./Passo4";
import { Passo5 } from "./Passo5";
import { Passo6 } from "./Passo6";
import { Passo7 } from "./Passo7";
import { Passo8 } from "./Passo8";
import { Passo9 } from "./Passo9";
import { Passo10 } from "./Passo10";
import { NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";
import { DMN_CATEGORIA, DMN_IND_FLUXO_RECAD, DMN_PLANO, DMN_SITUACAO_RECAD } from "../../domains";

interface Props { }

interface State {
  Erro: string;
  PassoAtivo: Passos;
  Recads: WebRecadPublicoAlvoEntidade[];
  Recad: WebRecadPublicoAlvoEntidade;
  RecadDados: WebRecadParticipanteDadosEntidade;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  condicaoAtivoAssistidoPlanoA: boolean;
  ContribuiComRisco: boolean;
  DadosPasso2: any;
  DadosPasso3: any;
  DadosPasso4: any;
  DadosPasso5: any;
  DadosPasso8: any;
  ListaArquivo: Array<ArquivoUploadItem>;
  ListaDependente: Array<DependenteEntidade>;
  NumeroPassoAtual: number;
  ListaPassos: Array<Passos>;
}

export enum Passos {
  SituacaoRecad = "SituacaoRecad",
  Passo1 = "Passo1",
  Passo2 = "Passo2",
  Passo3 = "Passo3",
  Passo4 = "Passo4",
  Passo5 = "Passo5",
  Passo6 = "Passo6",
  Passo7 = "Passo7",
  Passo8 = "Passo8",
  Passo9 = "Passo9",
  Passo10 = "Passo10",
}

export enum GrupoRecadastramento {
  ATIVO = "ATIVO",
  ASSISTIDO = "ASSISTIDO",
  ASSISTIDO_ESPECIAL = "ASSISTIDO_ESPECIAL",
  SALDADO_EXTRAORD = "SALDADO_EXTRAORD",
  PENSIONISTA = "PENSIONISTA",
}

export class Recadastramento extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("recadastramento");

  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Erro: "",
      PassoAtivo: Passos.SituacaoRecad,
      Recads: new Array<WebRecadPublicoAlvoEntidade>(),
      Recad: new WebRecadPublicoAlvoEntidade(),
      RecadDados: new WebRecadParticipanteDadosEntidade(),
      DadosOriginais: new WebRecadParticipanteDadosEntidade(),
      condicaoAtivoAssistidoPlanoA: false,
      ContribuiComRisco: false,
      DadosPasso2: {
        Nome: null,
        DataEmissao: null,
        OrgaoEmissor: null,
        Naturalidade: null,
        UfNaturalidade: null,
      },
      DadosPasso3: {
        EstadoCivil: null,
        NomeConjuge: null,
        CPFConjuge: null,
      },
      DadosPasso4: {
        Cep: null,
        Endereco: null,
        Numero: null,
        Complemento: null,
        Bairro: null,
        Cidade: null,
        Estado: null,
        Pais: null,
        Email: null,
        TelefoneResidencial: null,
        TelefoneCelular: null,
      },
      DadosPasso5: {
        Banco: null,
        Agencia: null,
        Conta: null,
      },
      DadosPasso8: {
        PPE: null,
      },
      ListaArquivo: new Array<ArquivoUploadItem>(),
      ListaDependente: new Array<DependenteEntidade>(),
      NumeroPassoAtual: 0,
      ListaPassos: new Array<Passos>(),
    };
  }

  componentDidMount = async () => {
    try {
      const Recads = await RecadastramentoService.BuscarPorCpf();
      if (Recads.length === 1 && Recads[0].IND_SITUACAO_RECAD !== DMN_SITUACAO_RECAD.NAO_HA) {
        await this.MontarDadosRecadastramento(Recads[0]);
        this.setState({
          PassoAtivo: Passos.SituacaoRecad,
        });
      }
      else {
        this.setState({
          NumeroPassoAtual: 0,
          PassoAtivo: Passos.SituacaoRecad,
        });
      }
      this.setState({
        Recads
      });
    } catch (err) {
      const e = err.response ? err.response.data : err;
      if (this.alerta.current) {
        this.alerta.current.adicionarErro(e);
      } else {
        this.setState({
          Erro: e,
        });
      }
    }
  };

  MontarDadosRecadastramento = async (Recad: WebRecadPublicoAlvoEntidade) => {
    try {
      const RecadDados = await RecadastramentoService.BuscarDadosPorCpf(Recad.OID_RECAD_PUBLICO_ALVO);

      const ContribuiComRisco = (await RecadastramentoService.BuscarContribPensao()).length > 0;

      const planos = await PlanoService.Buscar();

      const condicaoAtivoAssistidoPlanoA = planos.some(
        (x) =>
          x.CD_PLANO === DMN_PLANO.PREVIDENCIAL_A &&
          (Recad.IND_FLUXO_RECAD === DMN_IND_FLUXO_RECAD.ATIVO ||
            Recad.IND_FLUXO_RECAD === DMN_IND_FLUXO_RECAD.ASSISTIDO
          )
      );

      this.setState(
        {
          Recad,
          RecadDados,
          DadosOriginais: RecadDados,
          condicaoAtivoAssistidoPlanoA,
          ContribuiComRisco,
        },
        () => this.montarListaPassos(planos[0].CD_CATEGORIA)
      );
    } catch (err) {
      const e = err.response ? err.response.data : err;
      if (this.alerta.current) {
        this.alerta.current.adicionarErro(e);
      } else {
        this.setState({
          Erro: e,
        });
      }
    }
  }

  CondicaoPasso7 = () => {
    // Passo 7 deverá ser sempre ser mostrado para qualquer participante das categorias ATIVO e ASSISTIDO do PLANO A ("0001")
    // Passo 7 não estará disponível para os grupos SALDADO EXTRAORD. ASSISTIDO ESPECIAL e PENSIONISTA.
    // Passo 7 estará disponível apenas para quem contribui com RISCO - PENSÃO
    const GrupoPermitido =
      this.state.Recad.IND_FLUXO_RECAD !== DMN_IND_FLUXO_RECAD.SALDADOS &&
      // this.state.Recad.GRUPO_RECADASTRAMENTO !== GrupoRecadastramento.ASSISTIDO &&
      this.state.Recad.GRUPO_RECADASTRAMENTO !== GrupoRecadastramento.PENSIONISTA;
    return this.state.condicaoAtivoAssistidoPlanoA || (GrupoPermitido && this.state.ContribuiComRisco);
  };

  montarListaPassos = (categoria: string) => {
    // Passo 1 e 2 disponível para todos os grupos
    let passos = [Passos.SituacaoRecad, Passos.Passo1, Passos.Passo2];

    // pula passo 3 se for pensionista
    if (this.state.Recad.GRUPO_RECADASTRAMENTO !== GrupoRecadastramento.PENSIONISTA) {
      passos.push(Passos.Passo3);
    }

    // Passo 4 disponível para todos os grupos
    passos.push(Passos.Passo4);

    // pula passo 5 se NAO for assistido
    if (
      (this.state.Recad.IND_FLUXO_RECAD === DMN_IND_FLUXO_RECAD.ASSISTIDO ||
        (this.state.Recad.IND_FLUXO_RECAD === DMN_IND_FLUXO_RECAD.SALDADOS &&
          categoria !== DMN_CATEGORIA.DIFERIDO
        ))
      //(this.state.DadosOriginais.NUM_BANCO === "001" || this.state.DadosOriginais.NUM_BANCO === "033")
    ) {
      passos.push(Passos.Passo5);
    }

    const participanteSaldado = this.state.Recad.IND_FLUXO_RECAD === DMN_IND_FLUXO_RECAD.SALDADOS;

    if (!participanteSaldado) {
      // pula passo 6 se for pensionista ou saldado extraord
      if (
        this.state.Recad.GRUPO_RECADASTRAMENTO !== GrupoRecadastramento.PENSIONISTA //&&
        // this.state.Recad.IND_FLUXO_RECAD !== DMN_IND_FLUXO_RECAD.SALDADOS
      ) {
        passos.push(Passos.Passo6);
      }

      if (this.CondicaoPasso7()) {
        passos.push(Passos.Passo7);
      }
    }

    // Passo 8, 9 e 10 disponível para todos os grupos
    passos.push(Passos.Passo8);
    passos.push(Passos.Passo9);
    passos.push(Passos.Passo10);
    this.setState({
      ListaPassos: passos,
    });
  };

  Avancar = (PassoEspecifico: Passos | null = null) => {
    const passos = Object.values(this.state.ListaPassos);
    const atual = passos.indexOf(PassoEspecifico || this.state.PassoAtivo);

    this.setState({
      NumeroPassoAtual: this.state.NumeroPassoAtual + 1,
      PassoAtivo: PassoEspecifico !== null ? passos[atual] : passos[atual + 1],
    });
  };

  Voltar = (PassoEspecifico: Passos | null = null) => {
    const passos = Object.values(this.state.ListaPassos);
    const atual = passos.indexOf(PassoEspecifico || this.state.PassoAtivo);

    this.setState({
      NumeroPassoAtual: this.state.NumeroPassoAtual - 1,
      PassoAtivo: PassoEspecifico !== null ? passos[atual] : passos[atual - 1],
    });
  };

  Reiniciar = () => {
    window.location.reload();
  };

  // setPassoAtivo = (PassoAtivo: Passos, Direcao: string) => {
  //   const NumeroPassoAtual: number = Direcao === "Proximo" ? this.state.NumeroPassoAtual + 1 : this.state.NumeroPassoAtual - 1;
  //   this.setState({
  //     PassoAtivo,
  //     NumeroPassoAtual
  //   });
  // }

  setRecadDados = (RecadDados: WebRecadParticipanteDadosEntidade) => {
    this.setState({
      RecadDados,
    });
  };

  setListaArquivo = (ListaArquivo: Array<ArquivoUploadItem>) => {
    this.setState({
      ListaArquivo,
    });
  };

  setListaDependente = (ListaDependente: Array<DependenteEntidade>) => {
    this.setState({
      ListaDependente,
    });
  };

  setDadosOriginais = (DadosOriginais: WebRecadParticipanteDadosEntidade) => {
    this.setState({
      DadosOriginais,
    });
  };

  setDadosPasso = (Passo: string, Dados: any) => {
    const d: any = {};
    d[`Dados${Passo}`] = Dados;
    this.setState(d);
  };

  HouveAlteracao = (infoAntiga: any, infoNova: any) => {
    const a = this.isEmptyString(infoAntiga) ? "" : infoAntiga;
    const n = this.isEmptyString(infoNova) ? "" : infoNova;
    return a.toUpperCase() !== n.toUpperCase();
  };

  SelecionarAlteracao = (infoAntiga: any, infoNova: any) => {
    return this.HouveAlteracao(infoAntiga, infoNova) ? infoNova : null;
  };

  isEmptyString = (string: string) => {
    return string === "" || string === undefined || string === null || string.length === 0;
  };

  MontarDadosFinais = () => {
    let Dados = new WebRecadParticipanteDadosEntidade();
    Dados.NOME_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.NOME_ENTID, this.state.DadosPasso2.Nome);
    Dados.DT_EMIS_IDENT = this.SelecionarAlteracao(this.state.DadosOriginais.DT_EMIS_IDENT, this.state.DadosPasso2.DataEmissao);
    Dados.ORG_EMIS_IDENT = this.SelecionarAlteracao(this.state.DadosOriginais.ORG_EMIS_IDENT, this.state.DadosPasso2.OrgaoEmissor);

    Dados.CD_ESTADO_CIVIL = this.SelecionarAlteracao(this.state.DadosOriginais.CD_ESTADO_CIVIL, this.state.DadosPasso3.EstadoCivil);
    Dados.NOME_CONJUGE = this.SelecionarAlteracao(this.state.DadosOriginais.NOME_CONJUGE, this.state.DadosPasso3.NomeConjuge);
    Dados.CPF_CONJUGE = this.SelecionarAlteracao(this.state.DadosOriginais.CPF_CONJUGE, this.state.DadosPasso3.CPFConjuge);

    Dados.CEP_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.CEP_ENTID, this.state.DadosPasso4.Cep);
    Dados.END_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.END_ENTID, this.state.DadosPasso4.Endereco);
    Dados.NR_END_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.NR_END_ENTID, this.state.DadosPasso4.Numero);
    Dados.COMP_END_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.COMP_END_ENTID, this.state.DadosPasso4.Complemento);
    Dados.BAIRRO_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.BAIRRO_ENTID, this.state.DadosPasso4.Bairro);
    Dados.CID_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.CID_ENTID, this.state.DadosPasso4.Cidade);
    Dados.UF_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.UF_ENTID, this.state.DadosPasso4.Estado);
    Dados.CD_PAIS = this.SelecionarAlteracao(this.state.DadosOriginais.CD_PAIS, this.state.DadosPasso4.Pais);
    Dados.EMAIL_AUX = this.SelecionarAlteracao(this.state.DadosOriginais.EMAIL_AUX, this.state.DadosPasso4.Email);
    Dados.FONE_ENTID = this.SelecionarAlteracao(this.state.DadosOriginais.FONE_ENTID, this.state.DadosPasso4.TelefoneResidencial);
    Dados.FONE_CELULAR = this.SelecionarAlteracao(this.state.DadosOriginais.FONE_CELULAR, this.state.DadosPasso4.TelefoneCelular);

    Dados.NUM_BANCO = this.SelecionarAlteracao(this.state.DadosOriginais.NUM_BANCO, this.state.DadosPasso5.Banco);
    Dados.NUM_AGENCIA = this.SelecionarAlteracao(this.state.DadosOriginais.NUM_AGENCIA, this.state.DadosPasso5.Agencia);
    Dados.NUM_CONTA = this.SelecionarAlteracao(this.state.DadosOriginais.NUM_CONTA, this.state.DadosPasso5.Conta);

    Dados.POLIT_EXP = this.SelecionarAlteracao(this.state.DadosOriginais.POLIT_EXP, this.state.DadosPasso8.PPE);

    let DadosFinais = new WebRecadDadosConclusaoEntidade();
    DadosFinais.Participante = Dados;
    DadosFinais.ListaArquivo = this.state.ListaArquivo.map((a) => {
      return a.Oid;
    });
    DadosFinais.ListaDependentes = this.state.ListaDependente.filter(
      (d) => d.IND_OPERACAO !== null && d.IND_OPERACAO !== undefined && d.IND_OPERACAO !== ""
    );
    DadosFinais.CPF_Original = this.state.DadosOriginais.CPF_CGC;

    return DadosFinais;
  };

  renderHeader = () => {
    return (
      <>
        <h4>{"Bem-Vindo ao Recadastramento PREVIRB!"}</h4>

        <h5>{"Aqui você fará a atualização dos seus dados cadastrais de forma rápida e segura!"}</h5>
      </>
    );
  };

  renderPassoAtivo = () => {
    const p = {
      SituacaoRecad: <SituacaoRecad Avancar={this.Avancar} Recads={this.state.Recads} MontarDadosRecadastramento={this.MontarDadosRecadastramento} />,
      Passo1: <Passo1 RecadDados={this.state.RecadDados} Avancar={this.Avancar} NumeroPassoAtual={this.state.NumeroPassoAtual} />,
      Passo2: (
        <Passo2
          setDadosPasso={this.setDadosPasso}
          DadosOriginais={this.state.DadosOriginais}
          Dados={this.state.DadosPasso2}
          HouveAlteracao={this.HouveAlteracao}
          ListaArquivo={this.state.ListaArquivo}
          setListaArquivo={this.setListaArquivo}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo3: (
        <Passo3
          setDadosPasso={this.setDadosPasso}
          DadosOriginais={this.state.DadosOriginais}
          Dados={this.state.DadosPasso3}
          HouveAlteracao={this.HouveAlteracao}
          ListaArquivo={this.state.ListaArquivo}
          setListaArquivo={this.setListaArquivo}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo4: (
        <Passo4
          setDadosPasso={this.setDadosPasso}
          Dados={this.state.DadosPasso4}
          DadosOriginais={this.state.DadosOriginais}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo5: (
        <Passo5
          setDadosPasso={this.setDadosPasso}
          Dados={this.state.DadosPasso5}
          DadosOriginais={this.state.DadosOriginais}
          HouveAlteracao={this.HouveAlteracao}
          ListaArquivo={this.state.ListaArquivo}
          setListaArquivo={this.setListaArquivo}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo6: (
        <Passo6
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          DadosOriginais={this.state.DadosOriginais}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo7: (
        <Passo7
          DadosOriginais={this.state.DadosOriginais}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          setListaDependente={this.setListaDependente}
          ListaDependente={this.state.ListaDependente}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
          isEmptyString={this.isEmptyString}
        />
      ),
      Passo8: (
        <Passo8
          setDadosPasso={this.setDadosPasso}
          Avancar={this.Avancar}
          Voltar={this.Voltar}
          DadosOriginais={this.state.DadosOriginais}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
        />
      ),
      Passo9: <Passo9 Avancar={this.Avancar} Voltar={this.Voltar} NumeroPassoAtual={this.state.NumeroPassoAtual} />,
      Passo10: (
        <Passo10
          DadosOriginais={this.state.DadosOriginais}
          RecadDados={this.MontarDadosFinais()}
          ListaDependente={this.state.ListaDependente}
          Voltar={this.Voltar}
          Reiniciar={this.Reiniciar}
          NumeroPassoAtual={this.state.NumeroPassoAtual}
          Recad={this.state.Recad}
        />
      ),
    };
    return p[this.state.PassoAtivo];
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.RECADASTRAMENTO} {...this.props} ref={this.page}>
        {this.renderHeader()}

        {this.renderPassoAtivo()}

        <Alerta ref={this.alerta} tipo={TipoAlerta.danger} mensagem={this.state.Erro} />
      </MasterPage>
    );
  }
}
